import { FILTER_KEYS } from '@modules/test-development/pages/runs/v2/components/run-results-filter/filter-form/constants';
import api from '../api/instance';
import { Session } from '../models/session.model';

const namespace = '/sessions';
const logout_namespace = '/logout';
const show = () => {
  return api
    .get<Session>(namespace)
    .then((data) => new Session().deserialize(data))
    .catch((e) => Promise.reject(e));
};
const logout = (isRedirect?: boolean) => {
  //@ts-ignore
  window?.fcWidget?.user?.isExists().then((data) => {
    if (data.data == true) {
      //@ts-ignore
      window?.fcWidget?.user?.clear();
    }
  });
  return api.get<any>(logout_namespace).then((res) => {
    storage.removeItem('canShowUserLimitExceededBanner');
    storage.removeItem('store:filterData');
    storage.removeItem('testCaseFilterId');
    storage.removeItem('lastVisitedTestCaseId');
    storage.removeItem(FILTER_KEYS.BASE_FILTERS_KEY);
    if (isRedirect) {
      window.location.href = `${
        import.meta.env.VITE_ID_SERVICE_URL
      }logout?redirectTo=${window.location.href}`;
    }
  });
};
const SessionService = {
  show,
  logout,
};

export default SessionService;
